// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin: 5vh 0;
    width: 30vw;

    background-color: #289CEF;
    border-radius: 12px;

    padding: 2vh 2vw;
    text-align: center;
}

.detail-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5vh 0;

}

.detail-body label {
    font-size: 1.4em;
    color: white;
    font-weight: bold;
    margin-bottom: .5vh;
}

.detail-body input {
    font-size: 1.4em;
    font-weight: bold;
    border: none;
    border-radius: 12px;
}

.detail-body select {
    font-size: 1.4em;
    font-weight: bold;
    padding: .25vh;
}

.detail-submit {
    display: flex;
    justify-content: space-around;
    width: 70%;
}
.detail-submit > * {
    border-radius: 12px;
    padding: 1vh;
    background-color: #4E7B9B;
}

.detail-submit button:hover {
    background-color: #4E7B9B;
}
.detail-submit button {
    color: white;
}
.detail-submit a {
    text-decoration: none;
    color: white;
    font-size: 1.2em;
    font-weight: bold;
}

.role-datail-permissions {
    height: 40vh;
    overflow-y: scroll;
    border-radius: 12px;
}

.role-datail-permissions-permission {
    display: flex;
    justify-content: space-between;
    padding: 2vh 2vw;
    background-color: #4E7B9B;
    font-size: 1.2em;
    color: white;
}
.role-datail-permissions-permission:hover {
    background-color: #289cef;
}
.role-datail-permissions-permission input {
    margin-left: 2vw;
    width: 30px;
    height: 30px;
}

@media only screen and (width < 1100px) {
    .detail {
        width: fit-content;
    }
    .role-datail-permissions {
        height: 60vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/management/Detail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,aAAa;IACb,WAAW;;IAEX,yBAAyB;IACzB,mBAAmB;;IAEnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".detail {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    margin: 5vh 0;\n    width: 30vw;\n\n    background-color: #289CEF;\n    border-radius: 12px;\n\n    padding: 2vh 2vw;\n    text-align: center;\n}\n\n.detail-body {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 5vh 0;\n\n}\n\n.detail-body label {\n    font-size: 1.4em;\n    color: white;\n    font-weight: bold;\n    margin-bottom: .5vh;\n}\n\n.detail-body input {\n    font-size: 1.4em;\n    font-weight: bold;\n    border: none;\n    border-radius: 12px;\n}\n\n.detail-body select {\n    font-size: 1.4em;\n    font-weight: bold;\n    padding: .25vh;\n}\n\n.detail-submit {\n    display: flex;\n    justify-content: space-around;\n    width: 70%;\n}\n.detail-submit > * {\n    border-radius: 12px;\n    padding: 1vh;\n    background-color: #4E7B9B;\n}\n\n.detail-submit button:hover {\n    background-color: #4E7B9B;\n}\n.detail-submit button {\n    color: white;\n}\n.detail-submit a {\n    text-decoration: none;\n    color: white;\n    font-size: 1.2em;\n    font-weight: bold;\n}\n\n.role-datail-permissions {\n    height: 40vh;\n    overflow-y: scroll;\n    border-radius: 12px;\n}\n\n.role-datail-permissions-permission {\n    display: flex;\n    justify-content: space-between;\n    padding: 2vh 2vw;\n    background-color: #4E7B9B;\n    font-size: 1.2em;\n    color: white;\n}\n.role-datail-permissions-permission:hover {\n    background-color: #289cef;\n}\n.role-datail-permissions-permission input {\n    margin-left: 2vw;\n    width: 30px;\n    height: 30px;\n}\n\n@media only screen and (width < 1100px) {\n    .detail {\n        width: fit-content;\n    }\n    .role-datail-permissions {\n        height: 60vh;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
